import countries from "./data/countries.json";

export type Country = {
  name: { common: string };
  flag: string;
  cca3: string;
};

// Country data is bundled as static JSON rather than fetched at runtime. The
// previous restcountries.com integration broke repeatedly as the external API
// changed (v1–v4 deprecated; v5 now requires an API key and a 500 req/mo quota).
// Country names/codes are effectively static, so we ship them with the app.
export const fetchCountryIndex = async (): Promise<Country[]> => {
  return countries as Country[];
};
